import { z } from 'zod';

export const ownerDistributionBillStatusSchema = z.enum([
  'success_preview',
  'success_committed',
  'skipped_idempotent',
  'blocked_non_positive_spendable',
  'blocked_insufficient_liquidity_for_liabilities',
  'blocked_invalid_cap_table',
  'blocked_property_not_found',
] as const);

const ownerDistributionPayoutRowSchema = z.object({
  ownerId: z.string(),
  ownershipBasisPoints: z.number(),
  payoutCents: z.number(),
});

const ownerDistributionPaymentRowSchema = z.object({
  ownerId: z.string(),
  paymentId: z.string(),
  amountCents: z.number(),
  idempotencyKey: z.string(),
});

/** POST /accounting/owner-distributions response (dry-run or commit). */
export const ownerDistributionRunReportSchema = z.object({
  propertyId: z.string(),
  yyyyMm: z.string(),
  status: ownerDistributionBillStatusSchema,
  spendableCents: z.number(),
  approvedUnpaidBillExposureCents: z.number(),
  distributableCents: z.number(),
  rawBalanceCents: z.number(),
  reserveCents: z.number(),
  isReserveViolation: z.boolean(),
  capTableSumBasisPoints: z.number(),
  payouts: z.array(ownerDistributionPayoutRowSchema),
  journalEntryId: z.string().optional(),
  ownerDistributionPayments: z.array(ownerDistributionPaymentRowSchema).optional(),
  detail: z.string().optional(),
});
